import { BreadcrumbsConfig, LandingBreadcrumb } from '../model';
import { createBreadcrumbRoutes } from '../utils';
import { useLandingDataQuery } from './useLandingDataQuery.ts';
import { useNavigationItemsQuery } from './useNavigationItemsQuery';

export const useLandingPageBreadcrumbs = ({
    currentPath,
    knownBreadcrumbs,
}: BreadcrumbsConfig): LandingBreadcrumb[] | null => {
    const routes: string[] = createBreadcrumbRoutes(currentPath);
    const { landingData, isLoadingLandingData, isErrorLandingData } = useLandingDataQuery(routes);
    const { navigationItems, isLoadingNavigationItems, isErrorNavigationItems } = useNavigationItemsQuery(routes);

    if (isLoadingNavigationItems || isLoadingLandingData || (isErrorNavigationItems && isErrorLandingData)) {
        return null;
    }
    const hideBreadcrumbs = landingData?.find((l) => l.fields.slug === currentPath)?.fields?.hideBreadcrumbs;
    if (hideBreadcrumbs === true) {
        return null;
    }

    const breadcrumbs = routes
        .map((url): LandingBreadcrumb => {
            const known = knownBreadcrumbs?.find((breadcrumb) => breadcrumb.url === url);
            const landing = landingData?.find(({ fields }) => fields.slug === url);
            const navItem = navigationItems?.find(({ fields }) => fields?.url === url);

            const title = (known?.title || landing?.fields?.breadcrumbName || navItem?.fields?.title)?.trim();

            return title ? { title, url } : null;
        })
        .filter(Boolean);

    return breadcrumbs;
};
